import { Injectable } from '@angular/core';
import { Ephemeride } from 'app/models/ephemeride';
import { Observable } from "rxjs/Observable";

import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';


@Injectable()
export class EphemerideService {

  private url = `/api/ephemeride`;

  constructor(private http: HttpClient) {}

 /* public find(): Observable<[Ephemeride]> {
    const params = new HttpParams();
    return this.http.get<[Ephemeride]>(this.url, { params: params });
  }
*/

  public find(params: any): Observable<HttpResponse<Ephemeride[]>> {
    let httpParams = new HttpParams()
      .set('size', '50')
      .set('sortName', 'id')
      .set('sortType', 'DESC');
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    console.log(params, httpParams);
    return this.http.get<Ephemeride[]>(`${this.url}`, {
       observe: 'response',
       params: httpParams });

  }



  public findEtat(params: any): Observable<HttpResponse<Ephemeride[]>> {
    let httpParams = new HttpParams()
      .set('size', '50')
      .set('sortName', 'id')
      .set('sortType', 'DESC');
    for (const key in params) {
      if (params.hasOwnProperty(key)) {
        httpParams = httpParams.set(key, params[key]);
      }
    }
    console.log(params, httpParams);
    return this.http.get<Ephemeride[]>(`${this.url}`, { observe: 'response', params: httpParams });

  }




  public count(): Observable<[Ephemeride]> {
    const params = new HttpParams();
    return this.http.get<[Ephemeride]>(this.url, { params: params });
  }


  /**
   * create a  new ephemeride
   * @param ephemeride
   */
  create(ephemeride: Ephemeride) {
    console.log(ephemeride);

    return this.http.post(this.url, ephemeride).map(data => {
      console.log(data);
    });
  }

  creer(ephemeride: Ephemeride) {

    return this.http.post(this.url, ephemeride).map(data => {
      console.log(data);
    });
  }

  /**
   * supprimer ephemeride
   * @param ephemeride
   */

  delete(ephemeride: Ephemeride) {
    return this.http
      .delete(`${this.url}/${ephemeride.id}`)
      .map(data => {
        console.log(data);
      });
  }
  /**
   *modifier ephemeride
   * @param ephemeride
   */
  update(ephemeride: Ephemeride) {
    return this.http
      .put(`${this.url}/${ephemeride.id}`, ephemeride)
      .map(data => {
        console.log(data);
      });
  }

  get(id: Number): Observable<Ephemeride> {
    return this.http.get<Ephemeride>(`${this.url}/${id}`);
  }

}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/ephemeride.service.ts